import { authClient } from "@api/auth";
import Dashboard from "@components/Dashboard.vue";
import DashboardIndex from "@components/modules/dashboard/Index.vue";

import DevicesIndex from "@components/modules/devices/Index.vue";
import DevicesStream from "@components/modules/devices/Stream.vue";
import DevicesAdd from "@components/modules/devices/Add.vue";
import DevicesEdit from "@components/modules/devices/Edit.vue";
import DevicesView from "@components/modules/devices/View.vue";

import CustomersIndex from "@components/modules/customers/Index.vue";
import CustomersAdd from "@components/modules/customers/Add.vue";
import CustomersEdit from "@components/modules/customers/Edit.vue";
import CustomersView from "@components/modules/customers/View.vue";

import UsersIndex from "@components/modules/users/Index.vue";
import UsersAdd from "@components/modules/users/Add.vue";
import UsersEdit from "@components/modules/users/Edit.vue";
import UsersView from "@components/modules/users/View.vue";

import NotFound from "@components/modules/dashboard/404.vue";
import Unauthorized from "@components/modules/dashboard/403.vue";
import DashboardSecond from "@components/modules/dashboard/DashboardSecond.vue";

import Login from "@components/Login.vue";
import VueRouter from "vue-router";

export default store => {
  // Routes
  const routes = [
    {
      path: "/",
      component: Dashboard,
      meta: {
        authorize: true
      },
      children: [
        {
          path: "",
          name: "dashboard",
          component: DashboardIndex
        },
        // {
        //   path: 'buttons',
        //   name: 'Buttons',
        //   component: Buttons
        // },
        {
          path: "/devices",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: "devices",
              component: DevicesIndex
            },
            {
              path: "add",
              name: "addDevice",
              component: DevicesAdd
            },
            {
              path: ":serial/edit",
              name: "editDevice",
              component: DevicesEdit,
              props: true
            },
            {
              path: ":serial/view",
              name: "viewDevice",
              component: DevicesView,
              props: true
            },
            {
              path: ":serial/stream",
              name: "streamDevice",
              component: DevicesStream,
              props: true
            }
          ]
        },
        {
          path: "/customers",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            isAdmin: true
          },
          children: [
            {
              path: "",
              name: "customers",
              component: CustomersIndex
            },
            {
              path: "add",
              name: "addCustomer",
              component: CustomersAdd
            },
            {
              path: ":id/edit",
              name: "editCustomer",
              component: CustomersEdit,
              props: true
            },
            {
              path: ":id/view",
              name: "viewCustomer",
              component: CustomersView,
              props: true
            }
          ]
        },
        {
          path: "/users",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            isAdmin: true
          },
          children: [
            {
              path: "",
              name: "users",
              component: UsersIndex
            },
            {
              path: "add",
              name: "addUser",
              component: UsersAdd
            },
            {
              path: ":id/edit",
              name: "editUser",
              component: UsersEdit,
              props: true
            },
            {
              path: ":id/view",
              name: "viewUser",
              component: UsersView,
              props: true
            }
          ]
        },
        {
          path: "dashboard-second",
          name: "dashboard-second",
          component: DashboardSecond
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      props: route => ({
        to: route.query.to
      })
    },
    {
      path: "/logout",
      name: "logout"
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "/403",
      name: "403",
      component: Unauthorized
    },
    {
      path: "*",
      name: "404Default",
      component: NotFound
    }
  ];

  // Routing logic
  var router = new VueRouter({
    routes: routes,
    mode: "history",
    linkActiveClass: "open active",
    scrollBehavior: function(to, from, savedPosition) {
      return (
        savedPosition || {
          x: 0,
          y: 0
        }
      );
    }
  });
  router.beforeEach((to, from, next) => {
    if (to.name === "logout") {
      authClient.logout().then(next);
      store.dispatch("reset", {store});
    } else next();
  });
  router.beforeEach((to, from, next) => {
    if (to.matched.some(m => m.meta.authorize) && !authClient.authenticated) {
      next({
        name: "login",
        query: {
          to: to.fullPath
        }
      });
    } else next();
  });
  router.beforeEach((to, from, next) => {
    if (
      to.matched.some(m => m.meta.isAdmin) &&
      !store.getters["account/isAdmin"]
    ) {
      next({
        name: "403"
      });
    } else next();
  });
  router.beforeEach((to, from, next) => {
    if (
      to.name === "passwordChange" &&
      (!authClient.passwordResetToken || !authClient.passwordResetUserId)
    ) {
      next({
        name: "dashboard"
      });
    } else next();
  });
  router.afterEach((to, from) => {
    if (to.name === "logout") {
      router.replace({
        name: "dashboard"
      });
    }

    window.scrollTo(0, 0);
    document.querySelector("body").classList.remove("popup-opened");
  });
  authClient.addAxiosInterceptor(() => {
    const current = router.currentRoute;
    const to = current.name === "login" ? current.query.to : current.fullPath;
    router.push({
      name: "login",
      query: to
        ? {
            to
          }
        : {}
    });
  });
  return router;
};



// WEBPACK FOOTER //
// ./src/routes.js